import { LoaderFunctionArgs } from "react-router";
import { useInfo } from "../../context/useInfo";

export async function LayoutLoader({ params, context: loaderContext }: LoaderFunctionArgs<any>) {
    let context = loaderContext;
    if (typeof window !== "undefined" && window.__client_context) {
        context = window.__client_context
    }
    
    const info = (context || {info: null})["info"]
    return info
}